var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1664 14.0002C25.8104 14.0002 26.339 13.4763 26.2748 12.8358C26.0058 10.1573 24.8189 7.6543 22.9152 5.75103C21.0115 3.84775 18.5081 2.66136 15.8296 2.39298C15.188 2.32882 14.6653 2.85732 14.6653 3.50132V12.8347C14.6653 13.1441 14.7882 13.4408 15.007 13.6596C15.2258 13.8784 15.5225 14.0013 15.8319 14.0013L25.1664 14.0002Z",
    stroke: "#F0A634",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4114 18.5384C24.6692 20.2937 23.5083 21.8403 22.0303 23.0433C20.5522 24.2462 18.802 25.0688 16.9326 25.439C15.0632 25.8092 13.1316 25.7159 11.3066 25.1672C9.48159 24.6184 7.8188 23.631 6.46359 22.2912C5.10839 20.9514 4.10202 19.3 3.53248 17.4814C2.96294 15.6628 2.84756 13.7323 3.19644 11.8588C3.54531 9.98533 4.34782 8.22582 5.53379 6.73413C6.71977 5.24243 8.2531 4.06396 9.99974 3.30176",
    stroke: "#F0A634",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestor);
export default __webpack_public_path__ + "static/media/investor.c7014751e3449c2a74d2e85e456c5eb8.svg";
export { ForwardRef as ReactComponent };